import { removeTrailingSlash } from '@/utils/removeTrailingSlash';

export function getLabradorBackendUrl() {
  const backendUrl = process.env.OCELOT_LABRADOR_HOST;
  if (!backendUrl) throw new Error('Missing env: OCELOT_LABRADOR_HOST');
  return removeTrailingSlash(backendUrl);
}
